import {
  AfterContentChecked, Directive
} from '@angular/core';
import { Router } from '@angular/router';
import { AccordionLinkDirective } from './accordionlink.directive';


@Directive({
  selector: '[appAccordion]',
  standalone: true
})
export class AccordionDirective implements AfterContentChecked {
  private navlinks: Array<AccordionLinkDirective> = [];

  public closeOtherLinks(selectedLink: AccordionLinkDirective): void {
    this.navlinks.forEach((link: AccordionLinkDirective) => {
      if (link !== selectedLink) {
        link.selected = false;
      }
    });
  }

  public addLink(link: AccordionLinkDirective): void {
    this.navlinks.push(link);
  }

  public removeGroup(link: AccordionLinkDirective): void {
    const index = this.navlinks.indexOf(link);
    if (index !== -1) {
      this.navlinks.splice(index, 1);
    }
  }

  private checkOpenLinks(): void {
    this.navlinks.forEach((link: AccordionLinkDirective) => {
      if (link.group && typeof link.group === 'string') {
        const routeUrl = this.router.url;
        const currentUrl = routeUrl.split('/');
        if (currentUrl.indexOf(link.group) > 0) {
          link.selected = true;
          this.closeOtherLinks(link);
        }
      }
    });
  }

  public ngAfterContentChecked(): void {
    this.router.events
      .subscribe(() => this.checkOpenLinks());
  }

  public constructor(private router: Router) {
    setTimeout(() => this.checkOpenLinks());
  }
}
